import Script from 'next/script';
import { memo } from 'react';

const GTM_ID = process.env.GOOGLE_TAG_MANAGER_ID;
const SITE_ROOT = process.env.SITE_ROOT;

const validSiteSubdomains = ['www', 'aws-dev', 'aws-stage'];

const GoogleTagManagerScript = memo(function GoogleTagManagerScript() {
  if (
    !GTM_ID ||
    !SITE_ROOT ||
    !validSiteSubdomains.some((subdomain) =>
      SITE_ROOT.startsWith(`https://${subdomain}.`)
    )
  ) {
    return null;
  }

  const gtmBaseUrl = SITE_ROOT.replace(
    new RegExp(validSiteSubdomains.join('|')),
    // Force using production GTM as non-prod environments are currently broken.
    'tm.aws-prod'
  );

  return (
    <>
      <Script
        id="google-tag-manager-script"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          '${gtmBaseUrl}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_ID}');`,
        }}
      />
      <noscript>
        <iframe
          src={`${gtmBaseUrl}/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="Google Tag Manager"
        />
      </noscript>
    </>
  );
});

export default GoogleTagManagerScript;
